import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {HistoryService} from '../services/history.service';
import {SessionState} from 'src/app/shared/state/session-state';
import {Store} from "@ngxs/store";

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const historyService = inject(HistoryService);

  const isAuthenticated = store.selectSnapshot(SessionState.isAuthenticated);

  if (!isAuthenticated) {
    historyService.setLastVisitedRoute(state.url);
    router.navigateByUrl('/auth/login');
  }

  return isAuthenticated;
};
